import type { ComponentProps } from 'react';
import type { TCandidate } from 'types/candidate.types';

interface Props extends ComponentProps<'div'> {
  candidate?: TCandidate;
}

const CandidateFullName = ({ candidate, ...props }: Props) => {
  if (!candidate) {
    return <span>Unknown candidate name</span>;
  }

  if (candidate.fullName) {
    return <span {...props}>{candidate.fullName}</span>;
  }

  const firstName =
    candidate && candidate.first_name && candidate.first_name.length ? candidate.first_name : 'First name';
  const lastName = candidate && candidate.last_name && candidate.last_name.length ? candidate.last_name : 'Last name';

  return (
    <span {...props}>
      {firstName} {lastName}
    </span>
  );
};

export default CandidateFullName;
